import { useAtom } from 'jotai';

import { NotificationBannerBody } from './parts/Body';
import { NotificationBannerClose } from './parts/Close';
import { NotificationBannerHeader } from './parts/Header';
import { NotificationBannerHeading } from './parts/Heading';
import { NotificationBannerIcon } from './parts/Icon';

import { NotificationAtom } from '@/jotai/jotai';

export type NotificationBannerType = 'info1' | 'info2' | 'warning' | 'error' | 'success';
export type NotificationHeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type NotificationBannerStyle = 'standard' | 'color-chip';

export const bannerStyleClasses: { [key in NotificationBannerStyle]: string } = {
  standard: ' border-[3px] rounded-xl',
  'color-chip':
    'border-2 !pl-6 shadow-[inset_8px_0_0_0_var(--color-chip-color)] desktop:!pl-10 desktop:shadow-[inset_16px_0_0_0_var(--color-chip-color)]',
};

export const bannerTypeClasses: { [key in NotificationBannerType]: string } = {
  info1: 'text-blue-900 [--color-chip-color:currentColor] bg-green-50',
  info2: 'text-solid-gray-536 [--color-chip-color:currentColor] bg-solid-gray-50',
  warning:
    'text-warning-yellow-2 [--color-chip-color:theme(colors.yellow.400)] bg-warning-yellow-50',
  error: 'text-error-1 [--color-chip-color:currentColor] bg-red-50',
  success: 'text-success-2 [--color-chip-color:currentColor] bg-green-50',
};

type Props = {
  className?: string;
};

const NotificationBanner = ({ className }: Props) => {
  const [notification, setNotification] = useAtom(NotificationAtom);
  if (!notification) {
    return <></>;
  }
  const classNames = `
  grid grid-cols-[var(--icon-size)_1fr_minmax(0,auto)]
  gap-x-3 gap-y-4 border-current p-4 [--icon-size:calc(24/16*1rem)] desktop:gap-x-6 desktop:p-6 desktop:[--icon-size:calc(36/16*1rem)]
   ${bannerStyleClasses[notification.bannerStyle]} ${bannerTypeClasses[notification.type]} ${className ?? ''}
  `;

  const onClickClose = () => {
    setNotification(null);
  };

  return (
    <div className={classNames}>
      <div className="mt-[calc(2/16*1rem)] desktop:mt-0">
        <NotificationBannerIcon
          className="h-auto max-w-full"
          type={notification.type}
        />
      </div>
      <NotificationBannerHeader>
        <NotificationBannerHeading level={notification.headingLevel}>
          {notification.title}
        </NotificationBannerHeading>
        <NotificationBannerClose onClick={onClickClose} />
      </NotificationBannerHeader>
      <NotificationBannerBody>{notification.message}</NotificationBannerBody>
    </div>
  );
};

export default NotificationBanner;
